export default __webpack_public_path__ + "814744069bc4235681c8aea995f9d327.svg";